<template>
  <div>
    <b-alert show v-bind:style="`color:${team.tc};background-color:${team.bc};border-color:${team.bdc};`" type="">{{ team.text }}</b-alert>
    <!-- {{ JSON.stringify(team) }} -->
    <div v-if="rateLoading">Busy Loading...</div>
    <div v-else-if="rateError">Error: {{ rateError }}</div>
    <div v-else>
    <!-- <div v-if="!!rate"> -->
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
        <b-button v-if="!autoSave" type="submit" variant="primary">Submit</b-button>

        <div v-for="rating in rate" :key="rating.text">

          <b-form-group id="rating.text">
            <div class="my-3" v-b-popover.hover.top="`${rating.description}`">
              <h1>{{ rating.text }}</h1>
            </div> 
            <heart-rating 
              @rating-selected="changeEvent"
              :max-rating="rating.max" 
              :show-rating=false 
              inactive-color="#440522"
              active-color="#cc1166"
              :increment="1" 
              v-model="rating.value">
            </heart-rating>
          </b-form-group>
        </div>
        <b-button type="submit" variant="primary">Submit</b-button>
        <!-- <b-button type="reset" variant="danger">Reset</b-button> -->
        <!-- <div v-if="!userLoading && !rateError">
          Hi {{ JSON.stringify(user) }}
        </div> -->
        <b-button v-if="!!user && user.name === 'Bjorn Bergmann (Britehouse)'" v-on:click="asyncReload('rate')" variant="danger">Fetch</b-button>
      </b-form>
    </div>
  </div>
</template>
<script>
import { HeartRating } from "vue-rate-it";
import AuthService from '../services/auth.service';
import GraphService from '../services/graph.service';
import { db } from '../main';

/*
    var docRef = db.collection('people').doc(user.name)
    docRef.get().then(function(doc) {
      if (doc.exists) {
      } else {
          docRef.set({displayableId: user.displayableId, name: user.name, identityProvider: user.identityProvider, userIdentifier: user.userIdentifier});
      }
    }).catch(function(error) {
        // console.log("Error getting document:", error);
    });
*/

export default {
  name: 'food',
  created() {
    this.authService = new AuthService();
    this.graphService = new GraphService();
    // console.log(this.user.userIdentifier)
    // console.log(this.team.color)
    // this.docRef = db.collection('rating').doc(this.user.userIdentifier).collection(this.team.color);
    // this.docRef = db.collection('rating').doc(this.team.color + ':' + this.user.userIdentifier)
  },
  data() {
    return {
      checked: false,
      title: "Check me",
      show: true
    };
  },
  asyncData: {
    rate () {
      return new Promise((resolve, reject) => {
        var base = {
              
              appearance: {
                value: 3,
                text: "Appearance",
                description: "This is the description for being appearance",
                max: 5
              },
              
              aroma: {
                value: 3,
                text: "Aroma",
                description: "This is the description for being aroma",
                max: 5
              },

              origionality: {
                value: 3,
                text: "Origionality",
                description: "This is the description for being origional",
                max: 5
              },
             
              texture: {
                value: 3,
                text: "Texture",
                description: "This is the description for being texture",
                max: 5
              },
              
              taste: {
                value: 3,
                text: "Taste",
                description: "This is the description for being taste",
                max: 5
              }
            };

        db.collection('rating').doc(this.user.userIdentifier).collection('color').doc(this.team.color).get().then(function(doc) {
          if (doc.exists) {
            resolve(doc.data())
          } else {
            resolve(base)
          }
        }).catch(function(error) {
            console.log("Error getting document:", error);
            resolve(base);
        });
      })
    },
  },
  // firestore () {
  //   return {
  //     rate: db.collection('rating').doc(this.user.userIdentifier).collection('color').doc(this.team.color)
  //   }
  // },
  methods: {
    check() {
      this.checked = !this.checked;
    }
  },
  props: {
    team: {
      type: Object,
      required: true
    },
    autoSave: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    onSubmit(evt) {
      if (!!evt)
        evt.preventDefault();
      db.collection('rating').doc(this.user.userIdentifier).collection('color').doc(this.team.color).set(this.rate);
    },
    changeEvent(evt) {
      // console.log(evt)
      if (this.autoSave)
        this.onSubmit(null);
    },
    onReset(evt) {
      evt.preventDefault();
      console.log(this.rate);
      // this.rate.forEach(element => {
      //   // element.rate = 3
      //   console.log(element)
      // });

      for (var key in this.rate) {
          if (this.rate.hasOwnProperty(key)) {
              console.log(key + " -> ", this.rate[key]);
              // this.rate[key].rate = 3
          }
      }

      // Object.keys(this.rate).forEach(function(key) {
      //     console.log(key, this.rate[key]);
      // });

      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  components: {
    HeartRating
  }
};
</script>


// WEBPACK FOOTER //
// src/components/food.vue